import { render, staticRenderFns } from "./nominees-table.vue?vue&type=template&id=1586d7c1&"
import script from "./nominees-table.vue?vue&type=script&lang=js&"
export * from "./nominees-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports